var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stripe stripe--card"},[_c('div',{ref:"element",staticClass:"card-element"}),_c('transition',{attrs:{"name":"slide-down"}},[(_vm.errorMessage)?_c('p',{staticClass:"form__error"},[_vm._v("\n      "+_vm._s(_vm.errorMessage)+"\n    ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }